import axios from 'axios'
import { The, createJsonData, createFormData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

const workspace = getCurrentWorkspace()

// #region FORM

export const form = {
  create: (formData, options = {}) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/`,
        formData,
        config({ workspace, ...options })
      )
    ),

  getOne: (formSlug, options = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/forms/${formSlug}/`,
        config({ workspace, ...options })
      )
    ),

  getOneByAddress: (
    formAddress // this is used to display public view of the form & it doesn't need workspace access
  ) =>
    The(
      axios.get(`${APIURL}/v3.1/form-displays/address/${formAddress}`, config())
    ),

  getAll: (params = {}) =>
    The(axios.get(`${APIURL}/v4/forms/`, config({ workspace, params }))),

  copy: (formSlug, formData) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/${formSlug}/copy/`,
        createJsonData(formData),
        config({ workspace, contentType: HTTP.ContentTypes.JSON })
      )
    ),

  delete: (formSlug) =>
    The(axios.delete(`${APIURL}/v4/forms/${formSlug}/`, config({ workspace }))),

  edit: (formSlug, formData, contentType) =>
    The(
      axios.patch(
        `${APIURL}/v4/forms/${formSlug}/`,
        formData,
        config({ workspace, contentType })
      )
    ),
  import: (formData) =>
    The(
      axios.post(
        `${APIURL}/v4/form-excel-imports/`,
        createFormData(formData),

        config({ workspace })
      )
    ),
  getStats: (formSlug, options = {}) =>
    axios.get(`${APIURL}/v4/forms/${formSlug}/stats/`, config({ workspace })),

  getUtmTrackerQuery: (formObj) =>
    axios.post(
      `${APIURL}/v2/forms/form/get-utm-query/`,
      createFormData(formObj),
      config()
    ),

  resetGoogleSheetData: (formSlug) =>
    The(
      axios.post(
        `${APIURL}/v3/forms/${formSlug}/regenerate-gsheet-data/`,
        {},
        config({ workspace, contentType: HTTP.ContentTypes.JSON })
      )
    ),

  migrateToV2: (formSlug) =>
    The(
      axios.post(
        `${APIURL}/v3.0/forms/${formSlug}/migrate-version/`,
        createJsonData({
          create_default_app: true,
        }),
        config({ workspace, contentType: HTTP.ContentTypes.JSON })
      )
    ),
}

// #endregion FORM
